import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
var _excluded = ["keyname"];
import { Block } from 'react-login-page';
import { jsx as _jsx } from "react/jsx-runtime";
export var Title = props => {
  var {
      keyname = 'title'
    } = props,
    elmProps = _objectWithoutPropertiesLoose(props, _excluded);
  if (!elmProps.children) {
    elmProps.children = 'Login';
  }
  return /*#__PURE__*/_jsx(Block, _extends({}, elmProps, {
    keyname: keyname
  }));
};
Title.displayName = 'Login.Title';